import { render, staticRenderFns } from "./NewPasswordPage.vue?vue&type=template&id=3f05ce86&scoped=true&"
import script from "./NewPasswordPage.vue?vue&type=script&lang=js&"
export * from "./NewPasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./NewPasswordPage.vue?vue&type=style&index=0&id=3f05ce86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f05ce86",
  null
  
)

export default component.exports